import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Button from "../../../../components/main/button";
import FooterMain from "../../../../components/main/footer";

import Cookies from "../../../../utils/cookies";

interface Props {
    simple?: boolean;
}

const Footer: React.FC<Props> = ({ simple = false }) => {
    const [cookieNotification, setCookieNotification] = useState<boolean>(true);
    const [password, setPassword] = useState("");

    const cookie = new Cookies();

    return (
        <>
            <FooterMain />
        </>
    );
};

export default Footer;
